import { createContext, useCallback, useMemo, useState } from "react";

export const ThemeContext = createContext();

// Module-level so each theme keeps one object identity: re-applying the
// current theme is then a no-op instead of re-rendering every consumer.
const themes = {
  Light: {
    background2: "#70CEEA",
    background: "#1c2b40",
    hover: "#4a90e226",
    sidebar: "#1c2b40"
  },
  Dark: {
    background2: "#95a5a6",
    background: "#424242",
    hover: "#767a88",
    sidebar: "#181818"
  }
};

const getThemeKey = () => {
  try {
    const item = localStorage.getItem("theme");
    if (!item) return "Light";
    const themeData = JSON.parse(item);
    if (typeof themeData === "string") return themeData;
    return themeData?.title || "Light";
  } catch (e) {
    const item = localStorage.getItem("theme");
    return item || "Light";
  }
};

const getStoredTheme = () => themes[getThemeKey()] || themes.Light;

export const ThemeProvider = ({ children }) => {
  const [themedColor, setThemedColor] = useState(getStoredTheme);

  const updateTheme = useCallback(() => {
    setThemedColor(getStoredTheme());
  }, []);

  const value = useMemo(() => ({ themedColor, updateTheme }), [themedColor, updateTheme]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
